import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { getWaterSensorSettingsURL } from "../../../utils/urls";
import Layout from "../component/layout";
import AddUserTab from "./AddUserTab";
import BankDetailsTab from "./BankDetailsTab";
import BillerAddressTab from "./BillerAddressTab";
import CurrencyManagementTab from "./CurrencyManagementTab";
import DepartmentTab from "./DepartmentTab";
import EmailTab from "./EmailTab";
import FacilityTab from "./FacilityTab";
import InvoiceSettingsTab from "./InvoiceSettingsTab";
import LevySettingsTab from "./LevySettingsTab";
import SMSTab from "./SMSTab";
import WaterAlertsTab from "./WaterAlertsTab";
import TaxManagementTab from "./TaxManagementTab";
import UsersTab from "./UsersTab";
import DocumentType from "./documentTypeTab";
import FAQ from "./faq";
import IntegrationsTab from "./IntegrationsTab";
import PrivacyPolicyForm from "./PrivacyPolicyTab";
import TermsConditionsSetup from "./TermsTab";
import CommunityGuidelines from "./communityGuidelines";
import DigitaxTab from "./DigitaxTab";

const FacilitySettings = () => {
  const [facilityId, setFacilityId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [waterSensorEnabled, setWaterSensorEnabled] = useState(false);

  useEffect(() => {
    const loadFacilityData = async () => {
      const id = await getItem("selectedFacilityId");
      setFacilityId(id);
    };
    loadFacilityData();
  }, []);

  // Show Water Alerts only for facilities where the Water Sensor service is enabled.
  useEffect(() => {
    let cancelled = false;

    const loadWaterSensorServiceStatus = async () => {
      if (!facilityId) {
        setWaterSensorEnabled(false);
        return;
      }

      try {
        const response = await makeRequest2(
          getWaterSensorSettingsURL(facilityId),
          "GET",
        );
        const enabled = Boolean(
          response?.success &&
          response.data?.success &&
          response.data.data?.enabled,
        );
        if (!cancelled) setWaterSensorEnabled(enabled);
      } catch (error) {
        console.error("Error checking water sensor service status:", error);
        if (!cancelled) setWaterSensorEnabled(false);
      }
    };

    loadWaterSensorServiceStatus();
    return () => {
      cancelled = true;
    };
  }, [facilityId]);

  return (
    <Layout>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/resident/"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"/facility/settings_management/settings"}>
                    Settings
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body py-0">
              <ul
                className="nav nav-tabs profile-tabs"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="facility-tab"
                    data-bs-toggle="tab"
                    href="#facility"
                    role="tab"
                    aria-selected="true"
                  >
                    <i className="ti ti-building me-2"></i>Facility
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="adduser-tab"
                    data-bs-toggle="tab"
                    href="#adduser"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-building me-2"></i>Add User
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="users-tab"
                    data-bs-toggle="tab"
                    href="#users"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-building me-2"></i>Users
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="sms-tab"
                    data-bs-toggle="tab"
                    href="#sms"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-message me-2"></i>SMS
                  </a>
                </li>
                {waterSensorEnabled && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="water-alerts-tab"
                      data-bs-toggle="tab"
                      href="#water-alerts"
                      role="tab"
                      aria-selected="false"
                    >
                      <i className="ti ti-droplet me-2"></i>Water Alerts
                    </a>
                  </li>
                )}
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="email-tab"
                    data-bs-toggle="tab"
                    href="#email"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-mail me-2"></i>Email
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="bank-tab"
                    data-bs-toggle="tab"
                    href="#bank"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-building-bank me-2"></i>Bank Details
                  </a>
                </li>
                {/* New Biller Address Tab */}
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="biller-tab"
                    data-bs-toggle="tab"
                    href="#biller"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-address-book me-2"></i>Biller Address
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="currency-tab"
                    data-bs-toggle="tab"
                    href="#currency"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-coin me-2"></i>Currency
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="tax-tab"
                    data-bs-toggle="tab"
                    href="#tax"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-currency me-2"></i>Tax Management
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="tax-tab"
                    data-bs-toggle="tab"
                    href="#digitax"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-currency me-2"></i>Digitax
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="levy-tab"
                    data-bs-toggle="tab"
                    href="#levy"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-settings me-2"></i>Payments Settings
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="invoice-tab"
                    data-bs-toggle="tab"
                    href="#invoice"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-settings me-2"></i>Invoice Settings
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="department-tab"
                    data-bs-toggle="tab"
                    href="#department"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-building-warehouse me-2"></i>Departments
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="documentType-tab"
                    data-bs-toggle="tab"
                    href="#documentType"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-folders me-2"></i>Document Types
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="faq-tab"
                    data-bs-toggle="tab"
                    href="#faq"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-question-mark me-2"></i>FAQs
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="policy-tab"
                    data-bs-toggle="tab"
                    href="#policy"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-file-info me-2"></i>Privacy Policy
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="terms-tab"
                    data-bs-toggle="tab"
                    href="#terms"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-file-text me-2"></i>Terms And Conditions
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="guidelines-tab"
                    data-bs-toggle="tab"
                    href="#guidelines"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-file-text me-2"></i>Community Guidelines
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="integrations-tab"
                    data-bs-toggle="tab"
                    href="#integrations"
                    role="tab"
                    aria-selected="false"
                  >
                    <i className="ti ti-plug me-2"></i>Integrations
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="facility"
              role="tabpanel"
            >
              <FacilityTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="adduser" role="tabpanel">
              <AddUserTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="users" role="tabpanel">
              <UsersTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="sms" role="tabpanel">
              <SMSTab facilityId={facilityId} />
            </div>

            {waterSensorEnabled && (
              <div className="tab-pane fade" id="water-alerts" role="tabpanel">
                <WaterAlertsTab facilityId={facilityId} />
              </div>
            )}

            <div className="tab-pane fade" id="email" role="tabpanel">
              <EmailTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="bank" role="tabpanel">
              <BankDetailsTab facilityId={facilityId} />
            </div>

            {/* New Biller Address Tab Pane */}
            <div className="tab-pane fade" id="biller" role="tabpanel">
              <BillerAddressTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="currency" role="tabpanel">
              <CurrencyManagementTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="tax" role="tabpanel">
              <TaxManagementTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="digitax" role="tabpanel">
              <DigitaxTab facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="levy" role="tabpanel">
              <LevySettingsTab facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="invoice" role="tabpanel">
              <InvoiceSettingsTab facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="department" role="tabpanel">
              <DepartmentTab facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="documentType" role="tabpanel">
              <DocumentType facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="faq" role="tabpanel">
              <FAQ facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="policy" role="tabpanel">
              <PrivacyPolicyForm facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="terms" role="tabpanel">
              <TermsConditionsSetup facilityId={facilityId} />
            </div>
            <div className="tab-pane fade" id="guidelines" role="tabpanel">
              <CommunityGuidelines facilityId={facilityId} />
            </div>

            <div className="tab-pane fade" id="integrations" role="tabpanel">
              <IntegrationsTab facilityId={facilityId} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FacilitySettings;
